import IconLink from "components/common/iconLink/IconLink.component";
import "./styles.scss";

export default function ListIcon() {
  return (
    <div className="list-icons">
      <IconLink href="http://bit.ly/imagekaku" icon="far fa-images" />
      <IconLink href="/download/MyCV.pdf" icon="fas fa-file-pdf" />
      <IconLink href="http://bit.ly/2JrW9cK" icon="fab fa-github" />
      <IconLink
        href="http://bit.ly/2JqJkPJ"
        icon="fab fa-linkedin-in"
      />
    </div>
  );
}
